import { WeddingWebsiteQuery } from '../generated/graphql';

type PurchaseDoiman = WeddingWebsiteQuery['weddingWebsite']['purchaseDomain'] | undefined;

const useShouldPurchaseDomain = (purchaseDomian: PurchaseDoiman) => {
  return !(Boolean(purchaseDomian?.name) || Boolean(purchaseDomian?.isExpired));
};

export default useShouldPurchaseDomain;
